export class SnackBarStatus {
  isOpen: boolean = false
  message: string = ''
  status: string = ''
}
